import React, { useEffect, useRef, useState } from "react";
import { Box, Stack,Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { categories } from "../utils/constants";

const Categories = ({selectedCategory,setSelectedCategory,menuIcon,sidebar,setSidebar}) => {
  const refOne = useRef(null)
  useEffect(()=>{
    const handleClickOutside = (e)=>{
      // console.log(sidebar===true)
      if(!refOne.current.contains(e.target) && !menuIcon.current.contains(e.target)){
        setSidebar(false)
        // console.log("out")
      }
      
    }
    document.addEventListener("mousedown",handleClickOutside)

    return()=>{
      document.removeEventListener("mousedown",handleClickOutside)
    }


  })

  
  




  // console.log(sidebar)
  // const [selectedCategory, setSelectedCategory] = useState("");
  const navigate = useNavigate();
  const onhandleSubmit = (e,category) => {
      e.preventDefault();
      // console.log(category)
      setSelectedCategory(category)
      setSidebar(false)
      navigate(`/${category}`);
  };



  return (
    <>
      {true && (
      <>
        <Stack
          ref={refOne}
          direction="row"
          sx={{
            
            gap:"20px",
            padding: 3,
            backgroundColor:"black",
            height : "100vh",
            width:"240px",
            position:"absolute",
            zIndex:7,
            overflowY: "auto",
            // height: { sx: "auto", md: "95%" },
            flexDirection: { md: "column" },
            left : sidebar?"0":"-100%",
            // transitionProperty: "transform",
            // transform: "translate3d(0, 0, 0)",
            transition: sidebar?"200ms":"900ms",
            // width: "100vw",
            // height: "100vh",
            // backgroundColor: "rgba(200, 200, 200)",

          }}
        >
          <Typography align = "start" color = "white"   sx={{ fontSize: "1.6rem" ,fontWeight:"400"}}>
              Explore
          </Typography>
          {categories.map((category) => (
            <Stack

            // onhandleSubmit
            gap="15px"
              alignItems="center"
              justifyContent="start"
              direction="row"
              className="category-btn"
              onClick = {(e) => onhandleSubmit(e,category.name)}
              sx={{
                // marginLeft:2,
                borderRadius:"10px",
                "&:hover":{
                  backgroundColor:"#A0A0A0",
                  
                },
                cursor:"pointer",
                height:"40px",
                width:"100%",
                background: category.name === selectedCategory && "#A0A0A0",
                color: "white",
                fontWeight:300
              }}
              key={category.name}
            >
              <span style={{ color: category.name === selectedCategory ? "white" : "red", marginRight: "15px" }}>
                {category.icon}
              </span>
              <span >
                {category.name}
              </span>
            </Stack>
          ))}
        </Stack>
      </>
      
    )}
    
    </>
    
  
)};

export default Categories;